import gql from 'graphql-tag';

// 配信設定マスタ取得（deliveryIdを指定しない場合は全件取得）
export const GET_DELIVERY_MASTER = gql`
    query(
        $deliveryId: Int
    ) {
        GetDeliveryMaster(
            deliveryId: $deliveryId
        ) {
            DeliveryMasterList{
                delivery_id
                delivery_name
                delivery_date_code
                delivery_time
                delivery_type
                template_code
                real_time_flag
                valid_flag
            }
        }
    }
`;

// 配信設定マスタ更新
export const UPDATE_DELIVERY_MASTER = gql`
    mutation(
        $UpdateDeliveryMasterList: [UpdateDeliveryMasterList]
    ) {
        UpdateDeliveryMaster(
            UpdateDeliveryMasterList: $UpdateDeliveryMasterList
        ) {
            result
        }
    }
`;
